import React from 'react';

const Textarea = ({className, ...props}) => {
    return (
        <textarea className={`w-full p-1 bg-black bg-opacity-5 rounded shadow-inner ${className}`} {...props}/>
    );
};

export default Textarea;